import React from 'react'
import className from 'classnames'

export default (props) => {
  const { wide, heading, content } = props

  return (
    <div className='hero'>
      <div className={className('container', { 'container_wide': wide })}>
        <h1 className='hero__heading'>{ heading }</h1>
        { content &&
          <div className='hero__content'>
            { content }
          </div>
        }
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Layout/Hero/Hero.jsx